import {
  CREATE_ARTICLE,
  CREATE_CATEGORY,
  CREATE_REDIRECT_RULES,
  DELETE_ARTICLE,
  DELETE_CATEGORY,
  DELETE_REDIRECT_RULE,
  EXPORT_KNOWLEDGEBASE,
  GET_ARTICLES_CATEGORY,
  GET_ARTICLES_DOC,
  GET_ARTICLE_DETAIL,
  GET_CATEGORIES,
  GET_CATEGORY_DETAILS,
  GET_DOC_DETAILS,
  GET_EXPORT_DOC_DETAILS,
  GET_KNOWLEDGEBASE,
  GET_REDIRECT_RULE,
  IMPORT_KNOWLEDGEBASE,
  UPDATE_ARTICLE,
  UPDATE_CATEGORY,
  UPDATE_REDIRECT_RULE,
  UPLOAD_FAVICON_CUSTOMIZATION,
  UPLOAD_IMAGE_CUSTOMIZATION,
  UPLOAD_LOGO_ARTICLE,
  UPLOAD_LOGO_CATEGORY,
  UPLOAD_LOGO_CUSTOMIZATION,
} from 'actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case GET_DOC_DETAILS:
      return {
        ...state,
        docDetails: action.payload,
      }

    case 'EMPTY_GET_DOC_DETAILS':
      return {
        ...state,
        docDetails: {},
      }

    case UPDATE_REDIRECT_RULE: {
      const updateRuleData = () => {
        const indexToReplace = state.redirectRuleData.findIndex(item => item.id === action.payload.id)
        state.redirectRuleData.splice(indexToReplace, 1, action.payload)
        return state.redirectRuleData
      }

      return {
        ...state,
        redirectRuleData: state.redirectRuleData ? updateRuleData() : state.redirectRuleData,
      }
    }

    case CREATE_REDIRECT_RULES:
      return {
        ...state,
        createRedirectRuleStatus: action.status || action.error,
        redirectRuleData: [action.payload, ...state.redirectRuleData],
      }

    case 'CLEAR_CREATE_REDIRECT_RULES':
      return {
        ...state,
        createRedirectRuleStatus: null,
      }

    case DELETE_REDIRECT_RULE: {
      const deleteRedirectRule = () => {
        const data = [...state.redirectRuleData]
        const removeIndex = data.findIndex(item => item.id === action.payload)
        data.splice(removeIndex, 1)
        return data
      }
      return {
        ...state,
        redirectRuleData: state.redirectRuleData ? deleteRedirectRule() : state.redirectRuleData,
      }
    }

    case GET_KNOWLEDGEBASE:
      return {
        ...state,
        kbData: action.payload,
      }
    case GET_CATEGORIES:
      return {
        ...state,
        categories: action.payload,
      }

    case CREATE_CATEGORY:
      return {
        ...state,
        categoryDetail: action.payload,
      }

    case GET_ARTICLES_CATEGORY: {
      return {
        ...state,
        categoryArticles: action.payload,
      }
    }

    case GET_ARTICLES_DOC: {
      return {
        ...state,
        docArticles: action.payload,
      }
    }

    case GET_REDIRECT_RULE: {
      return {...state, redirectRuleData: action.payload}
    }

    case DELETE_CATEGORY: {
      const {categoryId} = action.reduxData
      return {
        ...state,
        categories: state.categories.filter(cat => cat.id !== categoryId),
      }
    }

    case UPDATE_CATEGORY: {
      return {
        ...state,
        updateCategoyDetail: action.payload,
      }
    }

    case CREATE_ARTICLE: {
      return {
        ...state,
        createArticleDetail: action.payload,
      }
    }

    case UPDATE_ARTICLE: {
      return {
        ...state,
        updateArticleDetail: action.payload,
      }
    }

    case 'CLEAR_UPDATE_ARTICLE_DETAILS':
      return {
        ...state,
        updateArticleDetail: null,
      }

    case GET_CATEGORY_DETAILS: {
      return {
        ...state,
        catDetails: action.payload,
      }
    }
    case GET_ARTICLE_DETAIL: {
      return {
        ...state,
        articleDetails: action.payload,
      }
    }
    case DELETE_ARTICLE:
      return {
        ...state,
        deleteArticleDetail: action.payload,
      }
    case UPLOAD_LOGO_CATEGORY: {
      return {
        ...state,
        images: {categoryOgImage: action.payload},
      }
    }
    case UPLOAD_LOGO_ARTICLE: {
      return {
        ...state,
        images: {articleOgImage: action.payload},
      }
    }
    case UPLOAD_IMAGE_CUSTOMIZATION: {
      return {
        ...state,
        backgroundImage: action.payload,
      }
    }
    case UPLOAD_LOGO_CUSTOMIZATION: {
      return {
        ...state,
        logo: action.payload,
      }
    }
    case UPLOAD_FAVICON_CUSTOMIZATION: {
      return {
        ...state,
        favicon: action.payload,
      }
    }

    case EXPORT_KNOWLEDGEBASE:
      return {
        ...state,
        exportData: action.payload,
      }

    case IMPORT_KNOWLEDGEBASE:
      return {
        ...state,
        importKnowledgebaseMsg: action.error?.message,
      }

    case 'CLEAR_IMPORT_KNOWLEDGEBASE':
      return {
        importKnowledgebaseMsg: null,
      }

    case GET_EXPORT_DOC_DETAILS:
      return {
        ...state,
        exportDocDetails: action.payload,
      }

    default:
      return state
  }
}
